import omitNestedNew from "../omitNestedNew";
export const removeTypename = (obj) => omitNestedNew(obj, '__typename');
export default removeTypename;